var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPauseinline = function SvgPauseinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 10 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4 13C4 13.5523 3.55228 14 3 14H1C0.447715 14 0 13.5523 0 13V1C0 0.447715 0.447715 0 1 0H3C3.55228 0 4 0.447715 4 1V13ZM10 13C10 13.5523 9.55228 14 9 14H7C6.44772 14 6 13.5523 6 13V1C6 0.447715 6.44772 0 7 0H9C9.55228 0 10 0.447715 10 1V13Z"
  })));
};
export default SvgPauseinline;